import { render, staticRenderFns } from "./LmsStudentProgress.vue?vue&type=template&id=4cee2bfc&scoped=true"
import script from "./LmsStudentProgress.vue?vue&type=script&lang=js"
export * from "./LmsStudentProgress.vue?vue&type=script&lang=js"
import style0 from "./LmsStudentProgress.vue?vue&type=style&index=0&id=4cee2bfc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cee2bfc",
  null
  
)

export default component.exports